import React, { useState } from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'white' | 'gray';
  className?: string;
  text?: string;
  skipBackground?: boolean;
  variant?: 'block' | 'inline';
}

export default function LoadingSpinner({ 
  size = 'md', 
  className = '',
  text,
  variant = 'block',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  // Use CDN asset for consistent availability across environments
  const loaderSrc = 'https://d38vo9vb903pq8.cloudfront.net/75x75.mp4';
  const [videoFailed, setVideoFailed] = useState(false);

  return (
    <div className={`flex flex-row items-center justify-center ${className} ${variant === 'inline' ? '' : 'bg-[#ffffff] rounded-lg p-10'}`}>
      {!videoFailed ? (
        <video
          src={loaderSrc}
          autoPlay
          loop
          muted
          playsInline
          onError={() => setVideoFailed(true)}
          className={`${sizeClasses[size]} ${variant === 'inline' ? '' : ''}`}
        />
      ) : (
        <div className={`${sizeClasses[size]} animate-spin rounded-full border-t-2 border-b-2 border-gray-400`}></div>
      )}
      {text && (
        <p className={`text-black-600 font-semibold ${variant === 'inline' ? 'ml-2 text-sm' : 'text-lg mt-2 ml-4'}`}>{text}</p>
      )}
    </div>
  );
} 